export default "static/media/processing-vscode.b73649f.svg"